webpackJsonp([10035159985014],{

/***/ 1829:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LabTrendRange","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"max","type":{"kind":"SCALAR","name":"Float","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"min","type":{"kind":"SCALAR","name":"Float","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-lab-trend-range-d15ad3febedc970c50c3.js